import React from 'react'
import styled from 'styled-components'

const Preview = props => {
  const { assistantList } = props

  return (
    <Wrapper>
      <PreviewWrapper>
        <PreviewBox>
          {assistantList.length > 0 ? (
            assistantList.map((assistant, i) => (
              <AssistantImg key={i}>
                <img src={assistant.assistantProfileImg} />
              </AssistantImg>
            ))
          ) : (
            <></>
          )}
        </PreviewBox>
      </PreviewWrapper>
    </Wrapper>
  )
}

export default Preview

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const PreviewWrapper = styled.div`
  width: 343px;
  height: calc(100dvh - 210px);
  border: 2px solid #000;
  background-color: #fff;
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

const PreviewBox = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: min-content;
  gap: 16px;
`

const AssistantImg = styled.div`
  width: 100%;
  aspect-ratio: 1 / 1; /* 정사각형 강제 */
  border-radius: 14px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 14px;
    display: block;
  }
`
